/**
 * Created by neo on 18.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { Nutrient, createNutrient } from './Nutrient';
import { CaloricBreakdown, createCaloricBreakdown } from '../CaloricBreakdown';
import { WeightPerServing, createWeightPerServing } from '../WeightPerServing';

export type NutrientMap = Record<string, Nutrient>;

export type NutritionInformation = {
  nutrients: NutrientMap;
  properties: NutrientMap;
  flavanoids: NutrientMap;
  caloricBreakdown: CaloricBreakdown;
  weightPerServing: WeightPerServing;
};

function createNutrientMap(json?: Record<string, any>): NutrientMap {
  return Object.entries(json ?? {}).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: createNutrient(value) }),
    {} as NutrientMap,
  );
}

export function createNutritionInformation(json?: Partial<NutritionInformation>): NutritionInformation {
  return makeAutoObservable({
    nutrients: createNutrientMap(json?.nutrients),
    properties: createNutrientMap(json?.properties),
    flavanoids: createNutrientMap(json?.flavanoids),
    caloricBreakdown: createCaloricBreakdown(json?.caloricBreakdown),
    weightPerServing: createWeightPerServing(json?.weightPerServing),
  });
}
